import React from "react";
import Modal from "./Modal";
import { actionAppCengold, actionAppCengoldHana } from "../lib/utils";
import * as C from "../constants";
import { useLocalStorage } from "../lib/useLocalStorage";

export function CengoldModal({ visible, title, onClose, children }) {
  const [serviceCode] = useLocalStorage(C.STORAGE_KEY.SERVICE_CODE);

  const runCengold = () => {
    console.log("runCengold");
    if (onClose) {
      onClose();
    }

    if (serviceCode === C.SERVICE_CODE.HANA) {
      actionAppCengoldHana();
    } else {
      actionAppCengold();
    }
  };

  const isOkInv = serviceCode === C.SERVICE_CODE.OKINV;
  const isHana = serviceCode === C.SERVICE_CODE.HANA;

  const topWrap = isHana ? "hana_wrap" : "";
  const scrollWrap = isOkInv ? "scroll_wrap ok_wrap" : "scroll_wrap";
  const btnClass = isHana ? "btn_mem navy" : "btn_mem blue";

  return (
    visible && (
      <Modal visible={visible}>
        <div className={topWrap}>
          <div className="apply_form">
            <div className={scrollWrap}>
              <div className="form_wrap">
                <h1>{title}</h1>
                <div className="con_tt">
                  {children}
                  <div className="btn_area col_2">
                    <span
                      className="btn_mem white close"
                      onClick={() => onClose()}
                    >
                      확인
                    </span>
                    <span className={btnClass} onClick={() => runCengold()}>
                      비단 앱 실행
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    )
  );
}
